var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lead-baner mx-auto"},[_c('div',{staticClass:"bg"},[_c('div',{staticClass:"image offer-height",style:(_vm.bgImage)},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }